import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { AppState } from '../../../../../app.service';
import { ICCService } from '../../icc.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { FleetConfiguration } from '../../model/fleet-configuration';
import { NetworkProfile } from '../../model/network-profile';
import { Util } from '../../utils';
import { NETWORK_TYPES } from '../../constants';
import { Network } from '../../../../network/network';
import { IpValidationUtils } from '../../../../../../common/validations/ip-validation-utils';
import { IPPool } from '../../model/ip-pool';

let $ = require('jquery');
let _ = require('lodash');

@Component({
    selector: 'select-network-profiles',
    styles: [require('../../icc.scss')],
    template: require('./select-network-profiles.html'),
      providers: [
      ICCService, TranslateService
    ]
})

export class SelectNetworkProfiles {
    @Input() fleetConfig: FleetConfiguration;
    @Input() clusterId: string;
    @Input() errorFlag: boolean;
    @Input() isEdit: boolean;
    @Input() errorMessage: string;
    @Output() networkProfileValidated: EventEmitter<any> = new EventEmitter();

    private subscribeHandler;
    private isTranslationready: boolean = true;
    private isLoading: boolean = false;
    private selectedVCUUID: string = '';
    private dvpgs: any[] = [];
    private virtualWires: any[] = [];
    private standardPortGroups: any = [];
    private allowAddRemoveOfProfile: boolean = true;
    private isExpanded: Array<boolean> = [true];
    private typeSelectedisLAN: Map<number, boolean> = new Map<number, boolean>();
    private NETWORK_TYPES: any = NETWORK_TYPES;
    private areAllInputsValid: boolean;
    private ipValidationUtils:IpValidationUtils;
    private isIPPoolValid:Array<boolean> = [false];
    private isNetworkConfigCompleted: boolean = false;
    private allNetworkProfilesValid: boolean = false;
    private showDeleteNetworkProfileDialog: boolean = false;
    private networkProfileIndexToBeRemoved: number;
    private showTransitPool: Array<boolean> = [false];
    private nsxIPPools: any[] = [];
    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
      const clusterIdChange = changes['clusterId'];
      if (clusterIdChange) {
          const cur = JSON.stringify(clusterIdChange.currentValue);
          const prev = JSON.stringify(clusterIdChange.previousValue);
          if (cur !== prev) {
              this.getNetworks();
              this.getNSXIPPools();
          }
      }

      const fleetConfigChange = changes['fleetConfig'];
      if(fleetConfigChange) {
        if(this.fleetConfig.networkProfiles.length > 0){
          this.allNetworkProfilesValid = this.validateNetworkProfiles();
          for( let index:number =0; index<this.fleetConfig.networkProfiles.length; ++index){
            let networkProfile:NetworkProfile = this.fleetConfig.networkProfiles[index];
            this.showTransitPool[index] = (networkProfile.transitPool.provider !== '');
            if(networkProfile.tags.length > 0){
              this.typeSelectedisLAN.set(index,Util.isNetworkLANFacing(this.fleetConfig.networkProfiles[index]));
            } else {
              this.typeSelectedisLAN.set(index,true);
            }
          }
        }
      }
    }

    constructor(public appState: AppState,
              public service: ICCService,
              private translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
        this.ipValidationUtils = new IpValidationUtils();
    }

    private getNetworks() {
      this.getStanadrdPortgroups();
      this.getDVPGs();
      this.getVirtualWires();
    }

    private getVirtualWires(){
      this.isLoading = true;
      if(this.fleetConfig.vcenterInstanceId !== ''){
        this.service.getVirtualWires(this.fleetConfig.vcenterInstanceId).subscribe(
          (data:any) =>{
            this.virtualWires = data;
            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
          }
        )
      }
    }

    private getDVPGs(){
      this.isLoading = true;
      if(this.fleetConfig.vcenterInstanceId !== ''){
        this.service.getDVPGs(this.fleetConfig.resourcePoolId ,this.fleetConfig.vcenterInstanceId).subscribe(
          (data) =>{
            this.dvpgs = data;
            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
          }
        )
      }
    }

    private getStanadrdPortgroups(){
      if(this.fleetConfig.vcenterInstanceId != ''){
        this.service.getStandardPortGroups(this.fleetConfig.vcenterInstanceId,[this.clusterId]).subscribe(
          (response:any) => {
            let networkIds: Array<string> = new Array<string>();
            this.standardPortGroups = [];
            for(let item of response.data.items){
              for(let network of item.portgroup){
                if(networkIds.indexOf(network.entity_id) === -1){
                  networkIds.push(network.entity_id);
                  this.standardPortGroups.push(network);
                }
              }
            }
          },
          (error) => {

          }
        )
      }
    }

    /*private showDeleteProfile(networkProfile:NetworkProfile, event, i: number) {
      if(!this.isEdit || networkProfile.isItNewlyAdded){
        this.showDeleteNetworkProfileDialog = true;
        this.networkProfileIndexToBeRemoved = i;
      }
    }*/

    private removeNetworkProfile(networkProfile:NetworkProfile, event, i: number){
        this.fleetConfig.networkProfiles.splice(i, 1);
        this.isIPPoolValid.splice(i,1);
        this.allNetworkProfilesValid  = this.validateNetworkProfiles();
    }

    private onDVPGChanged(event, networkProfile: NetworkProfile){
      let selectedDVPG = _.find(this.dvpgs, function(dvpg){
        return dvpg.id === event;
      })
      if(selectedDVPG){
        networkProfile.networkId = event
        networkProfile.networkName = selectedDVPG.name;
        networkProfile.networkType = selectedDVPG.type;
      }
      this.allNetworkProfilesValid  = this.validateNetworkProfiles();
    }

    private onStandardPortgroupChanged(event, networkProfile: NetworkProfile){
      let selectedPortGroup = _.find(this.standardPortGroups, function(portGroup){
        return portGroup.entity_id === event;
      })
      if(selectedPortGroup){
        networkProfile.networkId = event;
        networkProfile.networkName = selectedPortGroup.name;
        networkProfile.networkType = 'Network';
      }
      this.allNetworkProfilesValid  = this.validateNetworkProfiles();
    }

    private onVirtualWireChanged(event, networkProfile: NetworkProfile){
      let selectedVirtualWire = _.find(this.virtualWires, function(virtualWire){
        return virtualWire.entityId === event;
      })
      if(selectedVirtualWire){
        networkProfile.networkId = event;
        networkProfile.networkName = selectedVirtualWire.name;
        networkProfile.networkType = 'VirtualWire';
      }
      this.allNetworkProfilesValid  = this.validateNetworkProfiles();
    }

    private showLANTypes(networkProfile:NetworkProfile,index:number){
      this.typeSelectedisLAN.set(index,true);
      networkProfile.tags = [];
      this.allNetworkProfilesValid  = this.validateNetworkProfiles();
    }

    private showWANTypes(networkProfile:NetworkProfile,index:number){
      this.typeSelectedisLAN.set(index,false);
      networkProfile.tags = [];
      this.allNetworkProfilesValid  = this.validateNetworkProfiles();
    }

    private setTypeToNetwork(networkProfile:NetworkProfile,networkType:string,index:number,event){
      if(this.typeSelectedisLAN.get(index)){
        let index = networkProfile.tags.indexOf(networkType)
        if(index === -1){
          networkProfile.tags.push(networkType)
        } else {
          networkProfile.tags.splice(index,1);
        }
      } else {
        networkProfile.tags = [];
        networkProfile.tags.push(networkType);
      }
      this.allNetworkProfilesValid  = this.validateNetworkProfiles();
    }

    private validateOnGatewayChange(ipPool:IPPool,event) {
      if (event.target.validity.patternMismatch === false) {
        this.allNetworkProfilesValid = this.validateNetworkProfiles();
      } else {
        this.areAllInputsValid = false;
        this.allNetworkProfilesValid = false;
      }
    }

    private validateOnPrefixLengthChange(ipPool:IPPool, event) {
      if (event.target.validity.patternMismatch === false) {
        this.allNetworkProfilesValid  = this.validateNetworkProfiles();
      } else {
        this.areAllInputsValid = false;
        this.allNetworkProfilesValid = false;
      }
    }

    private validateIPPools(ipPool:IPPool, index) {
      let isValid = true;
      if(ipPool.provider === 'HCX'){
        const ipPoolsArray = ipPool.ipAddresses.split(',');
        for (let i = 0; i < ipPoolsArray.length; ++i) {
          const ipAddresses = ipPoolsArray[i].split('-');
          if (ipAddresses.length === 1) {
            ipAddresses[0] = ipAddresses[0].trim();
            ipPoolsArray[i] = ipAddresses[0];
            isValid = this.ipValidationUtils.isIpValid(ipAddresses[0]);
          } else if (ipAddresses.length === 2) {
            ipAddresses[0] = ipAddresses[0].trim();
            ipAddresses[1] = ipAddresses[1].trim();
            ipPoolsArray[i] = ipAddresses.join('-');
            isValid = this.ipValidationUtils.isIpValid(ipAddresses[0])
                      && this.ipValidationUtils.isIpValid(ipAddresses[1])
                      && this.ipValidationUtils.isStartAddressLtEndAddress(ipAddresses[0], ipAddresses[1]);
          } else {
            isValid = false;
          }

          if (isValid) {
            let firstIpInThePool = ( ipPool.defaultGateway && ipPool.defaultGateway !== '') ? ipPool.defaultGateway : ipAddresses[0];
            if (ipAddresses.length === 1) {
              isValid = this.ipValidationUtils.isRangeValid(
                          ipAddresses[0], ipAddresses[0], firstIpInThePool, ipPool.prefixLength);
            } else {
              isValid = this.ipValidationUtils.isRangeValid(
                          ipAddresses[0], ipAddresses[1], firstIpInThePool, ipPool.prefixLength);
            }
          }
          this.isIPPoolValid[index] = isValid;
          if (!isValid) {
            break;
          }
        }
      } else if(ipPool.provider === 'NSX'){
        if(ipPool.ipPoolId !== ''){
          isValid = true;
        } else {
          isValid = false;
        }
      } else if(ipPool.provider === undefined || ipPool.provider === ''){
        this.isIPPoolValid[index] = isValid;
        isValid = true;
      }
      return isValid;
    }

    private validateNetworkProfiles() {
        let validate: boolean = true;
        for( let index:number=0; index< this.fleetConfig.networkProfiles.length; index++ ){
           if(!this.validateNetworkProfile(this.fleetConfig.networkProfiles[index], index) ){
              validate = false;
              break;
           }
        }
        this.networkProfileValidated.emit({
          isValid: validate
        })
        this.allNetworkProfilesValid = validate;
        return validate;
    }

    private validateNetworkProfile(networkProfile:NetworkProfile, index){
        let validIpRanges = this.validateIPPools(networkProfile.ipPool, index);
        if(networkProfile.networkId === '' || networkProfile.networkId === undefined){
          return false;
        }
        if(networkProfile.tags.length === 0){
          return false;
        }
        //this.allNetworkProfilesValid  = ;
        //return this.allNetworkProfilesValid;
        return validIpRanges;
    }

    private addEmptyNetworkProfile(){
      let networkProfile = Util.getEmptyNetworkProfiles();
      this.fleetConfig.networkProfiles.push(networkProfile);
      this.isExpanded[this.fleetConfig.networkProfiles.length - 1] = true;
      this.isIPPoolValid[this.fleetConfig.networkProfiles.length - 1] = false;
      this.allNetworkProfilesValid  = this.validateNetworkProfiles();
    }

    private setIPAMProvider(networkProfile:NetworkProfile,provider:string){
      networkProfile.transitPool.provider = provider;
      this.validateNetworkProfiles();
    }

    private changeTransitPool(networkProfile,index){
      this.showTransitPool[index] = !this.showTransitPool[index];
      networkProfile.transitPool = new IPPool();
      this.validateNetworkProfiles();
    }

    private getNSXIPPools(){
      if(this.fleetConfig.vcenterInstanceId !== ''){
        this.service.getNSXIPPools(this.fleetConfig.vcenterInstanceId).subscribe(
          (data:any) => {
            this.nsxIPPools = data;
          },
          (error) => {
            console.log('error '+error);
          }
        )
      }
    }

    private onNsxIPPoolSelected(event, networkProfile:NetworkProfile){
      networkProfile.transitPool.ipPoolId = event;
      let selectedIPool = _.find(this.nsxIPPools, function(nsxIPPool){
        return nsxIPPool.entityId === event;
      })
      if(selectedIPool){
        networkProfile.transitPool.ipPoolName = selectedIPool.name;
      }
      this.allNetworkProfilesValid  = this.validateNetworkProfiles();
    }

    private setEntityType(networkProfile:NetworkProfile, entityType:string){
      networkProfile.networkType = entityType;
      networkProfile.networkId = '';
      this.allNetworkProfilesValid  = this.validateNetworkProfiles();
    }

    private shouldDisablePrefixLengh(isEdit:boolean,networkProfile:NetworkProfile){
      if(networkProfile.tags.indexOf(NETWORK_TYPES.DC1) !== -1 || networkProfile.tags.indexOf(NETWORK_TYPES.DC2) !== -1){
        return false;
      }
      return isEdit && !networkProfile.isItNewlyAdded; 
    }

}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/wizard/steps/select-network-profiles.component.ts